import { Component, Input, OnInit } from '@angular/core'
import { ProductReference, WindowRef } from '@spartacus/core'

import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { UrlUtils } from '../../utils/url-utils'
import { DataAnalyticsClickSource, DataAnalyticsEventLabel, MbConstants } from '../../mb-constants'
import { FilterProductsService } from 'src/app/mb/product/services/filter-products.service'
import { MbAddToCartService } from '../../services/mb-add-to-cart.service'

@Component({
  selector: 'mb-products-teaser-component',
  templateUrl: './products-teaser.component.html',
  styleUrls: ['./products-teaser.component.scss']
})
export class ProductsTeaserComponent implements OnInit {

  @Input() dataAnalyticsClickSource = DataAnalyticsClickSource.UNKNOWN
  @Input() dataAnalyticsEventLabel = DataAnalyticsEventLabel.UNKNOWN
  @Input() showBorder = false
  constants = MbConstants
  nestedReference$: Observable<Observable<ProductReference>[]> | undefined // nesting is necessary for CxCarousel Input
  @Input() references$: Observable<ProductReference[]> | undefined
  @Input() localTitle$: Observable<string> | undefined
  itemWidth = '195px'
  indicatorIcon = undefined
  @Input() title: string = ''

  constructor (protected filterProductsService: FilterProductsService,
               protected winRef: WindowRef,
               protected addToCartService: MbAddToCartService) {
  }

  ngOnInit (): void {
    if (this.references$) {
      this.nestedReference$ = this.references$.pipe(map(references => references.map(r => of(r))))
    }
  }
  showProductCode (item: ProductReference) {
    return !!(item.target?.code && item.target?.baseProduct)
  }

  getRouterLink (url: string) {
    return UrlUtils.getPath(url)?.toLowerCase()
  }

  getFragment (url: string) {
    return UrlUtils.getFragment(url)?.toLowerCase()
  }

  clearDataFromFilterProductService () {
    this.filterProductsService.clearAllData()
    this.scrollToTop()
  }

  scrollToTop () {
    this.winRef.nativeWindow?.scroll({ top: 0, behavior: 'smooth' })
  }

  addToCart (productCode: string) {
    this.addToCartService.addToCart({
      productCode,
      source: this.dataAnalyticsClickSource,
      eventLabel: this.dataAnalyticsEventLabel
    })
  }
}
